import { reviewStatus } from 'config';

export const REVIEW_COMMENT_SUMMARY_LIMIT = 160;

export const reviewActions = {
  PUBLISH: 'publish',
  UNPUBLISH: 'unpublish',
  REPROCESS: 'reprocess',
  SEND_TO_REVIEW: 'sendToReview',
  EDIT: 'edit',
  DELETE: 'delete',
};

export const reviewActionPermissions = {
  [reviewActions.PUBLISH]: 'publish_review',
  [reviewActions.UNPUBLISH]: 'unpublish_review',
  [reviewActions.REPROCESS]: 'reprocess_review',
  [reviewActions.SEND_TO_REVIEW]: 'send_review_to_review',
  [reviewActions.EDIT]: 'change_review',
  [reviewActions.DELETE]: 'delete_review',
};

const hiddenByStatus = {
  [reviewActions.PUBLISH]: [reviewStatus.PUBLISHED, reviewStatus.DELETED],
  [reviewActions.UNPUBLISH]: [reviewStatus.UNPUBLISHED, reviewStatus.DELETED],
  [reviewActions.REPROCESS]: [
    reviewStatus.PENDING_PROCESSING,
    reviewStatus.PROCESSING,
    reviewStatus.DELETED,
  ],
  [reviewActions.SEND_TO_REVIEW]: [
    reviewStatus.TO_REVIEW,
    reviewStatus.DELETED,
  ],
  [reviewActions.EDIT]: [reviewStatus.DELETED],
  [reviewActions.DELETE]: [reviewStatus.DELETED],
};

export const orderedReviewActions = [
  reviewActions.PUBLISH,
  reviewActions.UNPUBLISH,
  reviewActions.REPROCESS,
  reviewActions.SEND_TO_REVIEW,
  reviewActions.EDIT,
  reviewActions.DELETE,
];

export const canShowReviewAction = (action, status) =>
  !hiddenByStatus[action].includes(status);

export const getReviewActions = status =>
  orderedReviewActions.filter(action => canShowReviewAction(action, status));

export const reviewStatusList = [
  reviewStatus.PENDING_PROCESSING,
  reviewStatus.PROCESSING,
  reviewStatus.PUBLISHED,
  reviewStatus.UNPUBLISHED,
  reviewStatus.TO_REVIEW,
  reviewStatus.DELETED,
];

export const formatRule = rule => {
  if (typeof rule === 'string') return rule;
  if (!rule || typeof rule !== 'object') return '';

  const [name] = Object.keys(rule);
  if (!name) return '';
  const value = rule[name];
  if (value === null || value === undefined || value === '') return name;
  if (typeof value === 'object') return `${name}: ${JSON.stringify(value)}`;
  return `${name}: ${value}`;
};

export const formatMatchedRules = matchedRules => {
  if (!matchedRules) return [];
  if (Array.isArray(matchedRules)) {
    return matchedRules.map(formatRule).filter(Boolean);
  }
  if (typeof matchedRules === 'object') {
    return Object.keys(matchedRules).map(key =>
      formatRule({ [key]: matchedRules[key] }),
    );
  }
  return [String(matchedRules)];
};

export const summarizeReviewComment = (
  comment,
  limit = REVIEW_COMMENT_SUMMARY_LIMIT,
) => {
  if (!comment) return '';

  const normalizedComment = String(comment)
    .replace(/\s+/g, ' ')
    .trim();

  if (normalizedComment.length <= limit) return normalizedComment;

  return `${normalizedComment.slice(0, limit).trim()}...`;
};
